import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { closeCenteredModal } from "../../REDUX/actions/centeredModal";
import Button from "../Common/FormElements/Button/Button";
import { useDispatch } from "react-redux";
import { updateAvoirComment } from "../../REDUX/actions/avoir";
import TextArea from "../Common/FormElements/TextArea/TextArea";

const UpdateCommentDialog = ({ id, comment }) => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const [updatedComment, setUpdatedComment] = useState(comment);

  const handleSubmit = () => {
    dispatch(updateAvoirComment(id, updatedComment, t));

    dispatch(closeCenteredModal());
  };

  return (
    <div>
      <p className="f15 sBold">{t("Comment")} :</p>
      <TextArea
        name="note"
        className={"w-100 b-2-softGrey h100"}
        rows={4}
        value={updatedComment || ""}
        callback={(e) => setUpdatedComment(e.target.value)}
      />

      <div className="d-flex justify-content-center gap-3">
        <Button onClick={handleSubmit}>{t("Save")}</Button>
        <Button onClick={() => dispatch(closeCenteredModal())}>
          {t("Cancel")}
        </Button>
      </div>
    </div>
  );
};

export default UpdateCommentDialog;
